module.exports = __webpack_public_path__ + "880730db3e963b229abf2a70c94a260f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/sales_redisign-active.png
// module id = 477
// module chunks = 0